module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(!_vm.isLoggedIn) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "kedvenciam_all_area"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "single_kedvenciam_all stop_bor"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "last_small_box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "kedvenciam_all_area for_nw_form"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "single_kedvenciam_all",
    staticStyle: {
      "padding-right": "0",
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "thm_last_btn text-center"
  }, [_c('router-link', {
    staticClass: "reg-class",
    attrs: {
      "tag": "a",
      "to": "/login?order=true"
    }
  }, [_vm._v("Bejelentkezés / Regisztráció")])], 1)]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "50px",
      "padding-right": "15px",
      "padding-left": "15px"
    }
  }, [_vm._v("\n                                                        Ajánljuk, hogy jelentkezz be a vásárlásod könnyebb nyomonkövetése és a következő vásárlásaid megkönnyítése érdekében.\n                                                    ")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "last_small_box"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "kedvenciam_all_area for_nw_form"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "single_kedvenciam_all"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }, _vm.emailChanged]
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.emailValidText))])])])])])])])])])])])])])])]) : _vm._e(), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('data-view', {
    ref: "data1",
    attrs: {
      "data": _vm.wrapper.invoicingData
    }
  }), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "ked_menu_box"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.wrapper.sameInvoicingShipping),
      expression: "wrapper.sameInvoicingShipping"
    }],
    staticClass: "cb-shipping",
    attrs: {
      "type": "checkbox",
      "placeholder": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.wrapper.sameInvoicingShipping) ? _vm._i(_vm.wrapper.sameInvoicingShipping, null) > -1 : (_vm.wrapper.sameInvoicingShipping)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.wrapper.sameInvoicingShipping,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.wrapper.sameInvoicingShipping = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.wrapper.sameInvoicingShipping = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.wrapper, "sameInvoicingShipping", $$c)
        }
      }
    }
  })])])])])]), _vm._v(" "), (!_vm.wrapper.sameInvoicingShipping) ? _c('data-view', {
    ref: "data2",
    attrs: {
      "data": _vm.wrapper.shippingData
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "kedvenciam_all_area for_nw_form"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "single_kedvenciam_all mobile-padding"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "hazho"
  }, [_c('div', {
    staticClass: "hazho_box",
    class: {
      'disabled-cb': _vm.$store.getters.getBasket.priceTotalWithPackage < 5000
    }
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping),
      expression: "shipping"
    }],
    staticClass: "radio-custom",
    attrs: {
      "disabled": _vm.$store.getters.getBasket.priceTotalWithPackage < 5000,
      "id": "radioship-99",
      "name": "radio-group",
      "value": "999",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.shipping, "999")
    },
    on: {
      "change": function($event) {
        _vm.shipping = "999"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio-custom-label",
    attrs: {
      "for": "radioship-99"
    }
  }, [_c('span', [_vm._v("Házhozszállítás, min. 5000 Ft rendelési érték felett")]), _vm._v(" (+ " + _vm._s((_vm.$store.getters.getBasket.priceTotalWithShipping - _vm.$store.getters.getBasket.priceTotalWithPackage).toLocaleString('hu')) + " Ft)")])]), _vm._v(" "), _c('div', [_c('span', {
    staticStyle: {
      "margin-right": "20px"
    }
  }, [_vm._v("Törésbiztosítás igénylése (+ " + _vm._s(((_vm.$store.getters.getBasket.priceTotalWithShipping - _vm.$store.getters.getBasket.priceTotalWithPackage) * 0.75).toFixed(0).toLocaleString('hu')) + " Ft):")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.crackAssistance),
      expression: "crackAssistance"
    }],
    staticClass: "cb-shipping",
    attrs: {
      "disabled": _vm.$store.getters.getBasket.priceTotalWithPackage < 5000,
      "type": "checkbox",
      "placeholder": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.crackAssistance) ? _vm._i(_vm.crackAssistance, null) > -1 : (_vm.crackAssistance)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.crackAssistance,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.crackAssistance = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.crackAssistance = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.crackAssistance = $$c
        }
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "x_karulet"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.shops), function(s, i) {
    return _c('div', {
      staticClass: "col-sm-3"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-12 x_karulet_box"
    }, [_c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.shipping),
        expression: "shipping"
      }],
      staticClass: "radio-custom",
      attrs: {
        "id": 'radioshop-' + i,
        "name": "radio-group",
        "type": "radio"
      },
      domProps: {
        "value": s.id,
        "checked": _vm._q(_vm.shipping, s.id)
      },
      on: {
        "change": function($event) {
          _vm.shipping = s.id
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "radio-custom-label",
      attrs: {
        "for": 'radioshop-' + i
      }
    }, [_c('span', [_vm._v(_vm._s(s.name))])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2"
    }), _vm._v(" "), _c('div', {
      staticClass: "col-xs-10"
    }, [_c('p', [_vm._v(_vm._s(s.location.address))]), _vm._v(" "), (s.shippingDays != null && s.shippingDays.length > 0) ? _c('p', [_vm._v("Kiérkezési idő: " + _vm._s(s.shippingDays) + " nap")]) : _vm._e()])])])
  }))])])])])])])])]), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "kedvenciam_all_area"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "single_kedvenciam_all again_bg_secnd"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "thm_last_btn text-right"
  }, [_c('a', {
    on: {
      "click": _vm.placeOrder
    }
  }, [_vm._v("RENDELÉS LEADÁSA")])])])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "ked_menu_box"
  }, [_c('div', {
    staticClass: "ked_menu_box_cont"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "szem_title"
  }, [_c('p', [_vm._v("Folytatás bejelentkezés után")])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "ked_menu_box"
  }, [_c('div', {
    staticClass: "ked_menu_box_cont"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "szem_title"
  }, [_c('p', [_vm._v("Folytatás bejelentkezés nélkül")])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "vezteknev_title"
  }, [_c('h6', [_vm._v("E-mail cím*:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "ked_menu_box"
  }, [_c('div', {
    staticClass: "ked_menu_box_cont"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "szem_title"
  }, [_c('p', [_vm._v("SZÁMLÁZÁSI ADATOK")])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ked_menu_box_cont"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "szem_title"
  }, [_c('p', [_vm._v("SZÁLLÍTÁSI ADATOK")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', {
    staticClass: "vezteknev_title"
  }, [_c('h6', [_vm._v("Szállítási adatok megegyeznek a számlázási adatokkal")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "ked_menu_box"
  }, [_c('div', {
    staticClass: "ked_menu_box_cont"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "szem_title"
  }, [_c('p', [_vm._v("SZÁLLÍTÁSI MÓD")])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "atv"
  }, [_c('p', [_vm._v("Személyes átvétel")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "ked_menu_box"
  }, [_c('div', {
    staticClass: "ked_menu_box_cont"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "szem_title"
  }, [_c('p', [_vm._v("FIZETÉSI MÓD")])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "kedvenciam_all_area for_nw_form"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "single_kedvenciam_all now_lil_less"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "all_cards"
  }, [_c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_vm._v("\n                                        Online bankkártyás fizetés"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://kh.hu/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "images/kh.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cards_box"
  }, [_c('div', {
    staticClass: "card_box_lists"
  }, [_c('ul', [_c('li', [_c('a', [_c('img', {
    attrs: {
      "src": "images/crd1.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('li', [_c('a', [_c('img', {
    attrs: {
      "src": "images/crd2.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('li', [_c('a', [_c('img', {
    attrs: {
      "src": "images/crd3.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('li', [_c('a', [_c('img', {
    attrs: {
      "src": "images/crd4.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('li', [_c('a', [_c('img', {
    attrs: {
      "src": "images/crd5.png",
      "alt": ""
    }
  })])])])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38a1e412","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/main/components/pages/checkout/FlowData.vue
// module id = 110
// module chunks = 0 1 2